import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoImage from '../SDPDLOGO.png';

const loadImage = (src) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve(img);
        img.onerror = () => resolve(null);
    });
};

export const generateReceiptPDF = async (data) => {
    const doc = new jsPDF({ format: 'a4', orientation: 'portrait' }); 
    const img = await loadImage(logoImage);

    // ================= WATERMARK (Background) =================
    doc.setTextColor(242, 242, 242); 
    doc.setFontSize(38); 
    doc.setFont("helvetica", "bold");
    doc.text("SDPD PUBLIC SCHOOL", 105, 95, { angle: 25, align: "center" });

    // ================= HEADER =================
    if (img) { doc.addImage(img, 'PNG', 10, 10, 24, 24); }

    doc.setFontSize(22);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(211, 47, 47); 
    doc.text("SDPD PUBLIC SCHOOL", 105, 18, null, null, "center");
    
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text("Rajeshwar Enclave, Near Block Office, Bulandshahr Road, Anoopshahr", 105, 24, null, null, "center");
    
    doc.setFontSize(8);
    doc.setTextColor(26, 35, 126);
    doc.text("Affiliated to CBSE | School Code: 60851 | Affiliation No: 2132044", 105, 29, null, null, "center");

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(50, 50, 50);
    doc.text("Web: www.sdpdpublicschoolasr.in | Email: sdpdpublicschool@gmail.com | Ph: 8057674802", 105, 34, null, null, "center");
    
    doc.setDrawColor(26, 35, 126);
    doc.setLineWidth(0.5);
    doc.line(7, 38, 203, 38);

    // ================= RECEIPT INFO =================
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(211, 47, 47);
    doc.text("FEE RECEIPT", 105, 44, null, null, "center");

    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text(`Receipt No: ${data.receipt_no}`, 12, 50);
    const safeDate = new Date(data.date || new Date()).toLocaleDateString('en-IN');
    doc.text(`Date: ${safeDate}`, 155, 50);
    
    doc.setFont("helvetica", "normal");
    doc.text(`Payment Mode: ${data.mode || 'Cash'}`, 12, 55);

    doc.setFont("helvetica", "bold");
    doc.text(`SR No: ${data.sr_no}`, 12, 62);
    doc.text(`Class: ${data.class_name}`, 155, 62);
    
    doc.text(`Student Name: ${data.student_name}`, 12, 67);
    doc.text(`Mobile: ${data.mobile_no || 'N/A'}`, 155, 67);
    
    doc.setFont("helvetica", "normal");
    doc.text(`Father's Name: ${data.father_name || 'N/A'}`, 12, 72);

    // ================= HEAD-WISE TABLE (Strict > 0 Filter) =================
    const monthsStr = Array.isArray(data.tuitionMonths) ? data.tuitionMonths.join(', ') : (data.tuitionMonths || '');
    
    const tableData = [];
    if (Number(data.tuitionFee) > 0) tableData.push(["Tuition Fee", monthsStr, `Rs. ${data.tuitionFee}`]);
    if (Number(data.transportFee) > 0) tableData.push(["Transport Fee", monthsStr, `Rs. ${data.transportFee}`]);
    if (Number(data.registrationFee) > 0) tableData.push(["Registration Fee", "", `Rs. ${data.registrationFee}`]);
    if (Number(data.examFee) > 0) tableData.push(["Exam Fee", "", `Rs. ${data.examFee}`]);
    if (Number(data.boardFee) > 0) tableData.push(["Board Fee", "", `Rs. ${data.boardFee}`]);
    if (Number(data.admissionFee) > 0) tableData.push(["Admission Fee", "", `Rs. ${data.admissionFee}`]);
    if (Number(data.idCardFee) > 0) tableData.push(["ID Card Fee", "", `Rs. ${data.idCardFee}`]);
    if (Number(data.infraFee) > 0) tableData.push(["Infrastructure Fee", "", `Rs. ${data.infraFee}`]);
    if (Number(data.otherFee) > 0) tableData.push(["Other / Misc Fee", "", `Rs. ${data.otherFee}`]);
    if (Number(data.discount) > 0) tableData.push(["Discount / Concession", "", `- Rs. ${data.discount}`]);

    autoTable(doc, {
        startY: 76,
        margin: { left: 12, right: 12 }, 
        head: [['Fee Type', 'Details / Months', 'Amount']],
        body: tableData,
        theme: 'grid',
        headStyles: { fillColor: [26, 35, 126], textColor: 255 }, 
        bodyStyles: { fillColor: null }, 
        alternateRowStyles: { fillColor: null }, 
        styles: { fontSize: 8.5, cellPadding: 2, textColor: [0, 0, 0], lineColor: [200, 200, 200] },
        columnStyles: { 2: { halign: 'right', fontStyle: 'bold' } }
    });

    // ================= DYNAMIC BORDER & FOOTER PREVENTION =================
    const finalY = doc.lastAutoTable.finalY || 76;
    let boxHeight = 138.5; 
    
    // Agar rows zyada ho gaye aur box chota padh gaya, toh box lamba kar do
    if (finalY + 35 > 138.5) {
        boxHeight = finalY + 35; 
    }

    doc.setDrawColor(26, 35, 126); 
    doc.setLineWidth(0.8);
    doc.rect(5, 5, 200, boxHeight); 

    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.rect(7, 7, 196, boxHeight - 4);

    // ================= FOOTER =================
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(6, 95, 70); 
    doc.text(`GRAND TOTAL PAID: Rs. ${data.amount}`, 130, finalY + 8);

    if (data.balance_due !== undefined && data.balance_due !== null) {
        doc.setFontSize(9);
        doc.setTextColor(211, 47, 47); 
        const balanceText = data.balance_due > 0 ? `Rs. ${data.balance_due}` : "NIL (Cleared)";
        doc.text(`Balance Due (Till Current Month): ${balanceText}`, 12, finalY + 8);
    }
    
    if (data.remarks) {
        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        doc.text(`Remarks: ${data.remarks}`, 12, finalY + 14);
    }

    // Signature dynamically anchored to bottom of box
    const sigY = boxHeight - 8;
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Accountant Signature", 155, sigY - 5);
    
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text(`( ${data.accountant || 'Admin'} )`, 155, sigY);

    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(`* System Generated`, 12, sigY);

    doc.save(`${data.receipt_no}_${data.student_name}.pdf`);
};

export const generateReportPDF = async (transactions, period) => {
    const doc = new jsPDF({ orientation: 'landscape', format: 'a4' });
    const img = await loadImage(logoImage);

    if (img) { doc.addImage(img, 'PNG', 14, 10, 25, 25); }

    doc.setFontSize(22);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(211, 47, 47);
    doc.text("SDPD PUBLIC SCHOOL", 45, 17);
    
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text("Rajeshwar Enclave, Near Block Office, Bulandshahr Road, Anoopshahr", 45, 23);
    
    doc.setFontSize(9);
    doc.setTextColor(26, 35, 126);
    doc.text("Affiliated to CBSE | School Code: 60851 | Affiliation No: 2132044", 45, 28);

    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text("DAILY COLLECTION REGISTER", 14, 42);

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(50, 50, 50);
    doc.text(`Period: ${period.month}`, 14, 48);
    doc.text(`Generated On: ${new Date().toLocaleDateString('en-IN')}`, 245, 48);

    const tableData = transactions.map((t, idx) => [
        t.receipt_no, t.class_name, t.sr_no, t.name, t.father_name || 'N/A', 
        t.address || 'N/A', t.mobile_no || 'N/A', t.fee_type, t.status, `Rs. ${t.amount}`
    ]);

    autoTable(doc, {
        startY: 52,
        margin: { left: 14, right: 14 },
        head: [['Receipt No', 'Class', 'SR No', 'Student Name', 'Father Name', 'Address', 'Mobile', 'Fee Type', 'Mode', 'Amount']],
        body: tableData,
        theme: 'striped',
        headStyles: { fillColor: [26, 35, 126] },
        styles: { fontSize: 7.5, cellPadding: 2 }
    });

    const total = transactions.reduce((sum, t) => sum + Number(t.amount || t.amount_numeric), 0);
    const finalY = doc.lastAutoTable.finalY + 12;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text(`TOTAL COLLECTION: Rs. ${total.toLocaleString('en-IN')}`, 280, finalY, { align: 'right' });

    doc.save(`Collection_Report.pdf`);
};

export const generateDuesReportPDF = async (data, statusFilter, classFilter) => {
    const doc = new jsPDF({ orientation: 'landscape', format: 'a4' });
    const img = await loadImage(logoImage);

    if (img) { doc.addImage(img, 'PNG', 14, 10, 25, 25); }

    doc.setFontSize(22);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(211, 47, 47);
    doc.text("SDPD PUBLIC SCHOOL", 45, 17);
    
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text("Rajeshwar Enclave, Near Block Office, Bulandshahr Road, Anoopshahr", 45, 23);
    
    doc.setFontSize(9);
    doc.setTextColor(26, 35, 126);
    doc.text("Affiliated to CBSE | School Code: 60851 | Affiliation No: 2132044", 45, 28);

    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text("STUDENT DUES & PAID REPORT", 14, 42);

    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(50, 50, 50);
    let statusText = statusFilter === 'Pending' ? 'Pending Dues' : statusFilter === 'Cleared' ? 'Fully Paid' : 'All';
    doc.text(`Class: ${classFilter} | Status: ${statusText}`, 14, 48);
    doc.text(`Generated On: ${new Date().toLocaleDateString('en-IN')}`, 245, 48);

    let head = ['S.No', 'Class', 'SR No', 'Student Name', 'Father Name', 'Address', 'Mobile'];
    if (statusFilter !== 'Pending') head.push('Paid Amount'); 
    if (statusFilter !== 'Cleared') head.push('Unpaid Due');  

    const tableData = data.map((d, idx) => {
        let row = [
            idx + 1, d.class_name, d.sr_no, d.student_name, d.father_name || 'N/A', 
            d.address || 'N/A', d.mobile_no || 'N/A'
        ];
        if (statusFilter !== 'Pending') row.push(`Rs. ${d.paid_amount}`);
        if (statusFilter !== 'Cleared') row.push(`Rs. ${d.unpaid_amount}`);
        return row;
    });

    autoTable(doc, {
        startY: 52,
        margin: { left: 14, right: 14 },
        head: [head],
        body: tableData,
        theme: 'striped',
        headStyles: { fillColor: [26, 35, 126] },
        styles: { fontSize: 8, cellPadding: 2 }
    });

    let totalPaid = 0;
    let totalDue = 0;
    data.forEach(d => {
        totalPaid += Number(d.paid_amount);
        totalDue += Number(d.unpaid_amount);
    });

    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    
    if (statusFilter !== 'Pending') {
        doc.text(`Total Paid Amount: Rs. ${totalPaid.toLocaleString('en-IN')}`, 14, finalY);
    }
    if (statusFilter !== 'Cleared') {
        doc.text(`Total Pending Due: Rs. ${totalDue.toLocaleString('en-IN')}`, 280, finalY, { align: 'right' });
    }

    doc.save(`Dues_Report_${classFilter}_${new Date().toLocaleDateString('en-IN').replace(/\//g, '-')}.pdf`);
};